import { render, staticRenderFns } from "./ProjectTracker.vue?vue&type=template&id=20b40e12"
import script from "./ProjectTracker.vue?vue&type=script&lang=ts"
export * from "./ProjectTracker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports